import React from 'react';

import ModernBannerPromo from 'containers/can-store/modernTemplate/ModernBannerPromo';
import ModernCarouselPopular from 'containers/can-store/modernTemplate/ModernCarouselPopular';
import ModernHomeProducts from 'containers/can-store/modernTemplate/ModernHomeProducts';

import Box from '@mui/material/Box';

function ModernTemplateHome(): JSX.Element {
	return (
		<Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
			<ModernBannerPromo />
			<ModernCarouselPopular />
			<ModernHomeProducts />
		</Box>
	);
}

export default ModernTemplateHome;
